module.exports = __webpack_public_path__ + "static/media/ecobrite-logo.ac28753f.svg";